import React, { useState, useEffect } from 'react';
import {
    Button, Modal, ModalHeader, ModalBody, ModalFooter,
    InputGroup,
    InputGroupText, Row, Col
} from 'reactstrap';
import { Formik, Field } from 'formik';
import FormikInputField from 'components/common/Fields/FormikInputField';
import * as Yup from 'yup';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusCircle, faClose } from '@fortawesome/free-solid-svg-icons';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import FormikDatePicker from 'components/common/Fields/FormikDatePicker';
import Calendar from 'assets/icon/calendar-icon.svg';
import { dateFormate } from 'utils/columns';
import { cloneDeep, find } from 'lodash';
import { toast } from 'react-toastify';
import Confirm from 'components/Confirm';
import useAxios from 'hooks/useAxios';
import HoverImage from 'react-hover-image/build';
import SaveIcon from "assets/icon/icon-icon-options-order-complete.svg";
import SaveHoverIcon from "assets/icon/icon-icon-options-order-complete-hover.svg";
import save from "assets/icon/save.svg";
import Cancel from "assets/icon/CancelIcon-manufacture.svg";
import { color, gray } from 'd3';

// const initialValues = {
// 	ndc: '',
// 	ndcDescription: '',
// 	packageSize: '',
// 	adjustmentDate: '',
// 	packages: '',
// 	comment: '',
// 	users: ''
// };

const validationSchema = Yup.object({
    // packageSize: Yup.string().required('Required'),
    adjustmentDate: Yup.string().required('Required'),
    packages: Yup.string().required('Required'),
    comment: Yup.string().required('Required')
});

let hasDatePopupOpen = false;
// const EditModal = ({ isOpen, rowData, tenantID, toggle, editFlag, editData, refetch, packageSize, backUpData , dynamicData , setDynamicData , setHasToRest , hasToRest}) => {
const EditModal = ({ isOpen, rowData, tenantID, toggle, editFlag, editData, refetch, packageSize   , setHasToRest }) => {
    const API = useAxios();
    const [isConfirm, setConfirm] = useState(false);
    const [loading, setLoading] = useState(false);
    const [adjustmentDate, setAdjustmentDate] = useState('');
    const [packages, setPackages] = useState();
    // const [packageSize,setPackageSize]=useState();	
    const [comment, setComment] = useState();
    // const [hideRow, setHideRow] = useState(false);
    const [resultData, setResultData] = useState([]);
    // const [showResultRow, setShowResultRow] = useState(true);
    const [adjustmentList, setAdjustmentList] = useState([]);
    const [state, updateState] = useState({
        initialValues: {
            ndc: '',
            ndcDescription: '',
            packageSize: '',
            adjustmentDate: '',
            packages: '',
            comment: '',
            users: ''
        },
        rows: []
    });

    useEffect(() => {
        setAdjustmentDate(dateFormate(editData?.adjustmentDate));
        // console.log(editData?.adjustmentDate,888)
        setComment(editData?.comments);
        setPackages(editData?.packages);
        setState({
            initialValues: {
                adjustmentDate: editData?.adjustmentDate,
                packages: editData?.packages,
                comment: editData?.comments

            }
        });

    }, [editData]);


    const setState = (obj) => updateState((pre) => ({ ...pre, ...obj }));

    // const handleSubmit = (val, actions) => {
    //     const { resetForm, setSubmitting } = actions;
    //     var lst = {};
    //     lst.NDC = rowData.ndc;
    //     lst.DrugDescription = rowData.drugName;
    //     lst.PackageSize = packageSize;
    //     lst.AdjustmentDate = adjustmentDate;
    //     lst.Packages = packages;
    //     lst.Comments = comment;
    //     lst.ContractID = rowData.contractID;
    //     if (adjustmentList.length > 0) {
    //         let cCheck = adjustmentList.filter(m => m.PackageSize == lst.PackageSize && m.AdjustmentDate == lst.AdjustmentDate && m.Packages == lst.Packages);
    //         if (cCheck.length == 0) {
    //             setAdjustmentList(old => [...old, lst]);
    //         }
    //         else {
    //             toast.error('Duplicate entry not allowed.');
    //         }
    //     }
    //     else {
    //         setAdjustmentList(old => [...old, lst]);
    //     }
    //     handleReset();
    //     resetForm();
    //     setSubmitting(false);
    // };
    
    const handleReset = () => {
        setComment();
        initialValues.packageSize = '';
        setPackages();
        setAdjustmentDate('');
    };

    const handletoggle = () => {
        handleReset();
        setAdjustmentList([]);
        setResultData([]);
        // setConfirm(!isConfirm)
        // setHideRow(false);
        // setShowResultRow(true);
        toggle();
    }

    const { rows, initialValues } = state;

    const onHandleDelete = (id) => {
        const updatedRows = rows.filter((item) => item.id !== id);
        setState({
            rows: updatedRows
        });
    };
    const handleStartDate = (setFieldValue, startDate) => {
        let stDate = dateFormate(startDate);
        setAdjustmentDate(stDate);
        initialValues.adjustmentDate = stDate;
        setFieldValue('adjustmentDate', startDate);
    };

    const handleDateClick = (id) => {
        if (hasDatePopupOpen) {
            hasDatePopupOpen = false;
            return;
        }
        const calendarButton = document.getElementById(id);
        if (calendarButton) {
            calendarButton.click();
            hasDatePopupOpen = true;
        }
    };

    const handleMouseLeave = () => {
        hasDatePopupOpen = false;
    };
    const handlePacOnChange = ({ target: { value } }) => {
        setPackages(value)
    };
    const handlePacSizeOnChange = ({ target: { value } }) => {
        setState({
            initialValues: {
                packageSize: value
            }
        });
    };
    const handleCommentOnChange = ({ target: { value } }) => {
        setComment(value)
    };
    let saveDisabled = (adjustmentList.length > 0) ? false : true;


    const handleSaveConfirmation = () => {
        var lst = {};
        lst.NDC = rowData.ndc;
        lst.DrugDescription = rowData.drugName;
        lst.PackageSize = packageSize;
        lst.AdjustmentDate = adjustmentDate;
        lst.Packages = packages;
        lst.Comments = comment;
        lst.ContractID = rowData.contractID;
        setAdjustmentList([lst])

        if (adjustmentDate && comment && packages)
            setConfirm(!isConfirm);
    };


    const handleAdjustmentSubmit = async () => {
        handleSaveConfirmation();
        setLoading(true);
        let payload = {};
        payload = adjustmentList;
        if (editFlag == true) {
            payload = adjustmentList;
            payload[0].Id = editData.id;
            try {
                const result = await API.post(
                    `/${tenantID}/Inventory/Updateadjustments`,
                    payload);

                if (result?.data) {
                    toast.success('Adjustment Update successfully');
                    handletoggle();
                    //setResultData(old => ([...old, ...result.data]));
                    // setHideRow(true);
                    console.log(resultData);
                    // setShowResultRow(false);
                    setLoading(false);
                    refetch(true);
                    setHasToRest(true);
                }

            }
            catch (error) {
                console.log(error);
                setLoading(false);
            }
        }
        setLoading(false);
    }

    return (
        <div>
            <Modal isOpen={isOpen} toggle={handletoggle} size="xxl">
                <ModalHeader toggle={handletoggle}>{ "EDIT"}</ModalHeader>
                <ModalBody style={{ minHeight: 200 }}>
                    <Row >
                        <div className="table-card">
                            <table className="theme-table table table-striped border-0 w-100">
                                <thead>
                                    <tr>
                                        <th>NDC</th>
                                        <th>NDC Description</th>
                                        <th>Adjustment date</th>
                                        <th>Packages</th>
                                        <th className="w-20">Comments</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <Formik
                                        onSubmit={handleAdjustmentSubmit}
                                        initialValues={initialValues}
                                        validationSchema={validationSchema}
                                        enableReinitialize={true}
                                        children={(props) => {
                                            const { isSubmitting, handleAdjustmentSubmit, setSubmitting, setFieldValue } = props;
                                            return (
                                                <tr>
                                                    <td>
                                                        <span className="m-0 f-14 font-weight-500">{rowData?.ndc || '-'}</span>
                                                    </td>
                                                    <td>
                                                        <span className="m-0 f-14 font-weight-500">{rowData?.drugName || '-'}</span>
                                                    </td>
                                                    <td>
                                                        <InputGroup onMouseLeave={handleMouseLeave}>
                                                            <Field
                                                                type='text'
                                                                id='adjustmentDate'
                                                                name='adjustmentDate'
                                                                className='form-field-large inner-shadow-field required'
                                                                autoComplete='off'
                                                                style ={{color:gray}}
                                                                placeholder="Select a date"
                                                                initialValues={adjustmentDate}
                                                                value={adjustmentDate}
                                                                component={FormikDatePicker}
                                                                onChange={(value) => handleStartDate(setFieldValue, value)}
                                                                onKeyDown={(e) => {
                                                                    e.preventDefault();
                                                                }}
                                                            />
                                                            <InputGroupText
                                                                onClick={() => handleDateClick('adjustmentDate')}
                                                            >
                                                                <img src={Calendar} alt='' />
                                                            </InputGroupText>
                                                        </InputGroup>
                                                    </td>
                                                    <td>
                                                        <Field
                                                            id='packages'
                                                            name='packages'
                                                            className='required input' 
                                                            style={{color:'black'}}                                                           type='number'
                                                            placeholder="Enter Packages"
                                                            autoComplete='off'
                                                            defaultValue={packages}
                                                            component={FormikInputField}
                                                            onKeyUp={handlePacOnChange}
                                                        />
                                                    </td>
                                                    <td>
                                                        <Field
                                                            id="comment"
                                                            name="comment"
                                                            className='required'
                                                            type="textarea"
                                                            autoComplete="off"
                                                            placeholder="Enter Comments"
                                                            rows={1}
                                                            defaultValue={comment}
                                                            component={FormikInputField}
                                                            onKeyUp={handleCommentOnChange}
                                                        />
                                                    </td>

                                                </tr>
                                            );
                                        }}
                                    />

                                </tbody>
                            </table>
                        </div>

                    </Row>



                </ModalBody>
                <ModalFooter >
                    <Button className="reset" color="cancel" outline onClick={handletoggle}>
                        <span className="right_5">
                            <img src={Cancel} alt="" />
                        </span>{" "}
                        Cancel
                    </Button>{' '}
                    <Button color="primary" className='search' onClick={handleSaveConfirmation}>
                        <span className="right_5">
                            <img src={save} alt="" />
                        </span>{" "}
                        Save
                    </Button>
                </ModalFooter>
            </Modal>
            <Confirm
                isOpen={isConfirm}
                loading={loading}
                message='Are you sure you want to save?'
                onToggle={handleSaveConfirmation}
                onCancel={handleSaveConfirmation}
                onContinue={handleAdjustmentSubmit}
            />
        </div>
    );
};

export default EditModal;
